import {Controller} from "@hotwired/stimulus"

// Submits the enclosing form whenever an input changes — used by the Dispo
// search so picking a fire department or an alarm code reloads the result frame.
export class AutoSubmitController extends Controller {
	submit() {
		this.element.requestSubmit()
	}
}
